// Nextsj blog
import React, { Fragment, useEffect } from 'react';
import { createClient } from '../../prismicio';
import * as prismic from '@prismicio/client';
import { ThemeProvider } from 'styled-components';
import Head from 'next/head';
//import { ThemeProvider } from "styled-components";
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { saasModernTheme } from 'common/theme/saasModern';
import ResetCSS from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasModern/sassModern.style';
import Navbar from 'containers/SaasModern/Navbar';
import Footer from 'containers/SaasModern/Footer';
import Blog from 'containers/SaasModern/Blog';
import { Mixpanel } from 'utils/mixpanel';
import MetaHead from 'common/components/MetaHead';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';

export default function Page({ page, author, locale }) {
  useEffect(() => {
    Mixpanel.track('Article view', {
      'Article title': page?.data?.title,
    });
  }, []);

  const data = page?.data;
  return (
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <MetaHead
          title={page?.data?.meta_title}
          description={page?.data?.meta_description}
          keywords={page?.data?.meta_keywords}
          imageUrl={page?.data?.meta_image?.url}
        />

        <ResetCSS />
        <GlobalStyle />

        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar locale={locale} />
            </DrawerProvider>
          </Sticky>
          <Blog data={data} author={author} />
          <Footer locale={locale} />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
}
export async function getStaticPaths() {
  const client = createClient();

  const articles = await client.getAllByType('article', { lang: '*' });

  return {
    paths: articles.map((page) => {
      // If the language is 'en-us', don't include it in the path
      if (page.lang === 'en-us') {
        return `/blog/${page.uid}`;
      }
      // For other languages, include the language code in the path
      return `/${page.lang}/blog/${page.uid}`;
    }),
    fallback: false,
  };
}

export async function getStaticProps({ params, previewData, locale }) {
  const client = createClient({ previewData });
  const prismicLanguage = getPrismicLanguage(locale);

  const latestArticles = await client.getAllByType('article', {
    lang: prismicLanguage,
    limit: 3,
    orderings: [{ field: 'my.article.published_date', direction: 'desc' }],
  });

  try {
    const page = await client.getByUID('article', params.uid, {
      lang: prismicLanguage,
    });

    let author = {};
    if (page.data.author.uid) {
      author = await client.getByUID('author', page.data.author.uid, {
        lang: prismicLanguage,
      });
    }

    return {
      props: {
        page: page || {},
        latestArticles,
        author,
        locale,
      },
    };
  } catch (error) {
    console.error('Error fetching document:', error);
    return {
      notFound: true,
    };
  }
}
